import { formateDateandTime } from "helpers/formats";
import React, { useEffect } from "react";
import Select from 'react-select';

// components
import {
    Button,
    FormGroup,
    Input,
    Modal,
    Row,
    Col,
    Spinner
} from "reactstrap";

// services
import { getSessionCookie } from "../../services/session.js";
import { useState } from "react";
import { api_GET } from "services/api_service.js";
import { showMessage } from "services/message.js";

//CSS
import "assets/css/loading.css";
import { api_PUT } from "services/api_service.js";

export default function ModalDetalhesColetaItem({ stateModalDetalhesColetaItem, item, handleReturn }) {

    const session = getSessionCookie();
    const [stateModal, setstateModal] = useState(stateModalDetalhesColetaItem);

    const [evidenciasAntes, setEvidenciasAntes] = useState([]);
    const [evidenciasDepois, setEvidenciasDepois] = useState([]);

    const [showLoading, setshowLoading] = useState(false);

    const openImage = (image) => {
        window.open(session.pathVirtual + image);
    }

    useEffect(() => {
        setstateModal(stateModalDetalhesColetaItem);
    }, [stateModalDetalhesColetaItem]);

    const loadItemDetalhesColeta = () => {
        let antes = [];
        let depois = [];
        if (item != null && item.ordemColetaExecucao != null) {
            for (var i in item.ordemColetaExecucao) {
                item.ordemColetaExecucao[i].ordemColetaExecucaoEvidencia.filter(f => f.momentoEvidencia == "Antes").map(m => {
                    antes.push(m);
                });
                item.ordemColetaExecucao[i].ordemColetaExecucaoEvidencia.filter(f => f.momentoEvidencia == "Depois").map(m => {
                    depois.push(m);
                });
            }
        }
        setEvidenciasAntes(antes);
        setEvidenciasDepois(depois);
    }

    const [justificativa, setJustificativa] = useState(null);
    const [optionsJustificativas, setOptionsJustificativas] = useState([]);
    const loadJustificaticaModalidade = (modalidadeColetaId) => {
        api_GET(`Justificativa/GetByModalidadeId/${modalidadeColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                result.data = result.data?.map((value) => {
                    value.label = value.descricao;
                    value.value = value.descricao;
                    return value;
                });
                setOptionsJustificativas(result.data);
            }
        });
    }


    const handleAltualizarjustificativa = (value) => {
        api_PUT(`OrdemColeta/UpdateOrdemColetaExecucaoJustificativa/${item.ordemColetaExecucao[0].ordemColetaExecucaoId}/${value.justificativaId}/${item.ordemColetaExecucao[0].ordemColetaPontoColetaId}`).then(result => {
            if (result.status !== 204) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Sucesso", "Justificativa Atualizada com sucesso!", 'sucesso', handleReturn);
            }
        });
    }

    useEffect(() => {
        loadItemDetalhesColeta();
        if (item != null && item.ordemColetaExecucao.length > 0 && item.ordemColetaExecucao[0].justificativa) {
            setJustificativa(item.ordemColetaExecucao[0].justificativa)
            loadJustificaticaModalidade(item.ordemColetaExecucao[0].justificativa.modalidadeColetaId);
        }
    }, [item]);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Modal
                className="modal-dialog-centered"
                isOpen={stateModal}
                size="lg"
            >
                <div className="modal-header">
                    <h4 className="modal-title" id="modal-title-default">
                        Detalhes da Coleta
                    </h4>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => handleReturn()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col md="9">
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Status
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="status"
                                            type="text"
                                            value={item != null && item.statusColeta}
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Categoria
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="categoria"
                                            type="text"
                                            value={item != null && item.pontoColeta.categoria}
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Frequência
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="frequencia"
                                            type="text"
                                            value={item != null && item.pontoColeta.frequencia}
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="8">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Endereço
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="endereco"
                                            type="text"
                                            value={item != null && (item.pontoColeta.logradouro + ", " + (item.pontoColeta.numeroLogradouro == null ? "S/N" : item.pontoColeta.numeroLogradouro) + ", " + item.pontoColeta.bairro)}
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            Data/Hora
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            name="frequencia"
                                            type="text"
                                            value={item != null && item.ordemColetaExecucao != null && item.ordemColetaExecucao.length > 0 && formateDateandTime(item.ordemColetaExecucao[0].dataHoraExecucao)}
                                            disabled="true"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Foto do Cadastro
                                </label>
                                <br />
                                <img
                                    alt={"..."}
                                    height="150"
                                    className="mb-2 mr-2 d-inline"
                                    style={{ cursor: "pointer", width: "165px" }}
                                    onClick={() => item != null && openImage(item.pontoColeta.imagemCadastro)}
                                    src={item != null && session.pathVirtual + item.pontoColeta.imagemCadastro}
                                />
                            </FormGroup>
                        </Col>
                        {item != null && item.ordemColetaExecucao != null &&
                            item.ordemColetaExecucao.length > 0 &&
                            item.ordemColetaExecucao[0].justificativa != null &&
                            (((session.perfil === "Gestor" || session.perfil === "Master") &&
                                (item.ordemColeta.statusAvaliacaoOrdemColeta == "Aprovada" || item.ordemColeta.statusAvaliacaoOrdemColeta == "Reprovada")) ||
                                (session.perfil !== "Gestor" && session.perfil !== "Master")) &&
                            <Col md="12">
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-address" >
                                        Justificativa
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        name="frequencia"
                                        type="text"
                                        value={item != null && item.ordemColetaExecucao != null && item.ordemColetaExecucao.length > 0 && item.ordemColetaExecucao[0].justificativa != null && item.ordemColetaExecucao[0].justificativa.descricao}
                                        disabled="true"
                                    />
                                </FormGroup>
                            </Col>
                        }
                        {item != null && item.ordemColetaExecucao != null &&
                            item.ordemColetaExecucao.length > 0 &&
                            item.ordemColetaExecucao[0].justificativa != null &&
                            (session.perfil == "Gestor" || session.perfil == "Master") &&
                            (item.statusColeta == "Execução Parcial" || item.statusColeta == "Não Execução") &&
                            (item.ordemColeta.statusAvaliacaoOrdemColeta != "Aprovada" && item.ordemColeta.statusAvaliacaoOrdemColeta != "Reprovada") &&
                            <Col md="12">
                                <FormGroup>
                                    <label className="form-control-label"  >
                                        Justificativa
                                    </label>
                                    <Select
                                        options={optionsJustificativas?.filter(x => (item.statusColeta == "Execução Parcial" && x.coletaParcial) || (item.statusColeta == "Não Execução" && x.naoColeta))}
                                        name="frequencia"
                                        onChange={(e) => { handleAltualizarjustificativa(e) }}
                                        value={optionsJustificativas.length > 0 && optionsJustificativas?.filter(x => (item.statusColeta == "Execução Parcial" && x.coletaParcial) || (item.statusColeta == "Não Execução" && x.naoColeta)).find(x => x.descricao == justificativa.descricao)}
                                    />
                                </FormGroup>
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Evidências Antes
                                </label>
                                <br />
                                {evidenciasAntes.length > 0 && evidenciasAntes.map((n, key) => (
                                    <div style={{ display: "inline-block", textAlign: "center" }} ke={key}>
                                        <img
                                            alt={"..."}
                                            height="140"
                                            className="mb-2 mr-2"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => openImage(n.arquivo)}
                                            src={session.pathVirtual + n.arquivo}
                                        />
                                        <figcaption style={{ fontSize: "11px" }}>{formateDateandTime(n.dataHoraArquivo)}</figcaption>
                                    </div>
                                ))}
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-address" >
                                    Evidências Depois
                                </label>
                                <br />
                                {evidenciasDepois.length > 0 && evidenciasDepois.map((n, key) => (
                                    <div style={{ display: "inline-block", textAlign: "center" }} ke={key}>
                                        <img
                                            alt={"..."}
                                            height="140"
                                            className="mb-2 mr-2"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => openImage(n.arquivo)}
                                            src={session.pathVirtual + n.arquivo}
                                        />
                                        <figcaption style={{ fontSize: "11px" }}>{formateDateandTime(n.dataHoraArquivo)}</figcaption>
                                    </div>
                                ))}
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="modal-footer">
                    <Button color="secondary" type="button" onClick={() => handleReturn()}>
                        Fechar
                    </Button>
                </div>
            </Modal>
        </>
    );
}
